import axios from "axios";
import {  useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Cookies from "js-cookie"
import toast from "react-hot-toast";
import { BASE_URL } from "./ApiEndpoints";
// import ApiEndpoints, {BASE_URL, BASE_URL_Upload} from './commonComponents/ApiEndpoints'

export default function EditTransactionModal ({show, onHide,onUpdate,  data, selectedId}){
   const [formData, setFormData] = useState({
    payment_method: "",
    transaction_amount: "",
    transaction_date: "",
    transaction_id: "",
    discount: ""
  });
  console.log("Data from fees:", data)

 useEffect(() => {
    const transaction = data.find((t) => t.id === selectedId);
    if (transaction) {
      setFormData({
        payment_method: transaction.payment_method || "",
        transaction_amount: transaction.transaction_amount || "",
        transaction_date: transaction.start_date || "", 
      transaction_id: transaction.transaction_id ? String(transaction.transaction_id) : "",
        discount: transaction.discount || ""
      });
    }
  }, [selectedId, data]);

  const handleInputChange = (e) => {
  const { name, value } = e.target;

  // Update formData first
  setFormData((prev) => {
    const updatedData = { ...prev, [name]: value };

    // Clear transaction_id if payment method is "cash"
    if (name === "payment_method" && value.toLowerCase() === "cash") {
      updatedData.transaction_id = ""; // clear it
    }

    return updatedData;
  });
};



const handleSaveChanges = async (e) => {
  e.preventDefault();

  try {
    const storedUser = Cookies.get("user");
    let token = null;

    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        token = user.token; // Extract token from parsed user
      } catch (error) {
        console.error("Failed to parse user token", error);
        return;
      }
    }

    if (!token) {
      alert("Unauthorized: No token found");
      return;
    }

  const res =   await axios.put(
      BASE_URL +`/fees/update/${selectedId}`,
     {
       ...formData,
      transaction_id: String(formData.transaction_id || "")
     },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    toast.success(res.data.message);
    if(onUpdate) onUpdate()
    onHide();
  } catch (error) {
    console.error("Update failed", error);
    toast.error(error.response?.data?.message);
  }
};


  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton className="bg-warning text-dark">
        <Modal.Title>Edit Transaction</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Payment Method</Form.Label>
            <Form.Select
              name="payment_method"
              value={formData.payment_method}
              onChange={handleInputChange}
            >
              <option value="">Select</option>
                <option value="online">Online</option>
                <option value="cash">Cash</option>
                <option value="cheque">Cheque</option>

            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Transaction Amount</Form.Label>
            <Form.Control
              name="transaction_amount"
              value={formData.transaction_amount}
              onChange={handleInputChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Transaction Date</Form.Label>
            <Form.Control
            type="date"
              name="transaction_date"
              value={formData.transaction_date}
              onChange={handleInputChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Transaction ID</Form.Label>
            <Form.Control
              rows={3}
              name="transaction_id"
              value={formData.transaction_id}
              onChange={handleInputChange}
            />
          </Form.Group>
           <Form.Group className="mb-3">
            <Form.Label>Discount</Form.Label>
            <Form.Control
              rows={3}
              name="discount"
              value={formData.discount}
              onChange={handleInputChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" 
        onClick={onHide}
        >
          Cancel
        </Button>
        <Button variant="warning" 
        onClick={handleSaveChanges}
        >
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}